export default __webpack_public_path__ + "static/Spotify-21441016fd942bb6c3171772130406f3.png";